<!-- create-employee.component.html -->
<div class="container-xxl">
  <button class="btn btn-link px-0  py-4" (click)="goBack()">
    <i class="fa fa-arrow-left"></i> {{ 'BACK' | translate }}
  </button>
  <h2>{{ 'CREATE_EMPLOYEE' | translate }}</h2>
  <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="givenName" class="form-label"
        >{{ 'GIVEN_NAME' | translate }}<span class="text-danger">*</span></label
        >
        <input
          type="text"
          formControlName="givenName"
          class="form-control rounded-5"
          id="givenName"
          required
          />
        @if (employeeForm.get('givenName'); as givenNameControl) {
          <div class="text-danger">
            @if (givenNameControl.touched && givenNameControl.errors?.['required']) {
              <small>
                {{ 'GIVEN_NAME_REQUIRED' | translate }}
              </small>
            }
          </div>
        }
      </div>
      <div class="mb-3">
        <label for="familyName" class="form-label"
          >{{ 'FAMILY_NAME' | translate }}<span class="text-danger">*</span></label
          >
          <input
            type="text"
            formControlName="familyName"
            class="form-control rounded-5"
            id="familyName"
            required
            />
          @if (employeeForm.get('familyName'); as familyNameControl) {
            <div
              class="text-danger"
              >
              @if (familyNameControl.touched && familyNameControl.errors?.['required']) {
                <small
                  >
                  {{ 'FAMILY_NAME_REQUIRED' | translate }}
                </small>
              }
            </div>
          }
        </div>
        <div class="mb-3">
          <label for="email" class="form-label"
            >{{ 'EMAIL_ADDRESS' | translate }}<span class="text-danger">*</span></label
            >
            <input
              type="email"
              formControlName="email"
              class="form-control rounded-5"
              id="email"
              required
              />
            @if (employeeForm.get('email'); as emailControl) {
              <div class="text-danger">
                @if (emailControl.touched && emailControl.errors?.['required']) {
                  <small>
                    {{ 'EMAIL_REQUIRED' | translate }}
                  </small>
                }
                @if (emailControl.touched && emailControl.errors?.['email']) {
                  <small>
                    {{ 'VALID_EMAIL' | translate }}
                  </small>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="role" class="form-label">Role<span class="text-danger">*</span></label>
            <select formControlName="role" class="form-control rounded-5" id="role" required>
              <option value="hr">HR</option>
              <option value="hr-admin">HR Admin</option>
            </select>
          </div>
          <div class="mb-3">
            <label for="language" class="form-label"
              >{{ 'LANGUAGE' | translate }}<span class="text-danger">*</span></label
              >
              <select
                formControlName="language"
                class="form-control rounded-5"
                id="language"
                required
                >
                @for (language of languages; track language) {
                  <option [value]="language.id">
                    {{ language.attributes.name }}
                  </option>
                }
              </select>
              @if (employeeForm.get('language'); as languageControl) {
                <div class="text-danger">
                  @if (languageControl.touched && languageControl.errors?.['required']) {
                    <small>
                      {{ 'LANGUAGE_REQUIRED' | translate }}
                    </small>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="phoneNumber" class="form-label">{{ 'PHONE_NUMBER' | translate }}</label>
              <input
                type="tel"
                formControlName="phoneNumber"
                class="form-control rounded-5"
                id="phoneNumber"
                />
            </div>
            <button
              type="submit"
              class="btn btn-primary my-3 rounded-5 text-white px-3 btn-sm"
              [disabled]="isLoading"
              >
              @if (!isLoading) {
                <span>{{ 'CREATE' | translate }}</span>
              }
              @if (isLoading) {
                <span><i class="fa fa-spinner fa-spin"></i></span>
              }
            </button>
          </form>
        </div>
